var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.425781,
    y: 0.803711,
    width: 67.6721,
    height: 64.8525,
    rx: 32.4262,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4707 14.0117H42.053V20.2446H26.4707V14.0117Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5335 14.531V19.7251H26.99V14.531H41.5335ZM42.5723 13.4922H25.9512V20.7639H42.5723V13.4922Z",
    fill: "#374151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2383 17.1279H48.2864V52.4478H20.2383V17.1279Z",
    fill: "#F9FAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7669 17.6482V51.9292H20.7576V17.6482H47.7669ZM48.8057 16.6094H19.7188V52.9681H48.8057V16.6094Z",
    fill: "#374151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.665 46.2148H36.8591V52.4478H31.665V46.2148Z",
    fill: "#374151"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3406 46.7341V51.9282H32.1853V46.7341H36.3406ZM37.3794 45.6953H31.1465V52.9671H37.3794V45.6953Z",
    fill: "#374151"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1465 39.4615H37.3794V42.5779H31.1465V39.4615ZM31.1465 33.2285H37.3794V36.345H31.1465V33.2285ZM31.1465 26.9956H37.3794V30.1121H31.1465V26.9956ZM31.1465 20.7627H37.3794V23.8792H31.1465V20.7627ZM39.4571 39.4615H45.69V42.5779H39.4571V39.4615ZM39.4571 33.2285H45.69V36.345H39.4571V33.2285ZM39.4571 26.9956H45.69V30.1121H39.4571V26.9956ZM39.4571 20.7627H45.69V23.8792H39.4571V20.7627ZM22.8359 39.4615H29.0689V42.5779H22.8359V39.4615ZM39.4571 45.6944H45.69V48.8108H39.4571V45.6944ZM22.8359 45.6944H29.0689V48.8108H22.8359V45.6944Z",
    fill: "#374151"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8359 33.2305H29.0689V36.3469H22.8359V33.2305Z",
    fill: "#374151"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8359 26.9971H29.0689V30.1135H22.8359V26.9971Z",
    fill: "#374151"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8359 20.7637H29.0689V23.8801H22.8359V20.7637Z",
    fill: "#374151"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnr);
export default __webpack_public_path__ + "static/media/anr.0eff4fd06c5346c0224b948f70fc698b.svg";
export { ForwardRef as ReactComponent };